import { useEffect, useState, useRef, useCallback } from "react";
import { Button, Grid, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Translations from "src/layouts/components/Translations";
import PageHeader from "src/@core/components/page-header";
import { DefaultPaginationSettings } from "src/constants/general.const";
import { axiosInstance } from "src/network/adapter";
import { ApiEndPoints } from "src/network/endpoints";
import { toastError, toastSuccess } from "src/utils/utils";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/hooks/useAuth";
import TableLounge from "src/views/tables/TableLounge";
import DialogStatus from "src/views/dialog/DialogStatus";
import DialogApproveReject from "src/views/dialog/DialogApproveReject";
import Dialoglounge from "src/views/dialog/DialogLounge";



const Lounge = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const { rolePremission, isMasterAdmin } = useAuth()

    // status dialog
    const [statusDialogOpen, setStatusDialogOpen] = useState(false);
    const [statusToUpdate, setStatusToUpdate] = useState(null);

    const toggleChangeStatusDialog = (e, statusToUpdate = null) => {
        setStatusDialogOpen((prev) => !prev);
        setStatusToUpdate(statusToUpdate);
    };

    //pagination
    const [search, setSearch] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(DefaultPaginationSettings.ROWS_PER_PAGE);


    // Testimonials for lounge
    const [loungeData, setLoungeData] = useState([])
    const [loungeDialogOpen, setLoungeDialogOpen] = useState(false);
    const [loungeDialogMode, setLoungeDialogMode] = useState("add");
    const [loungeToEdit, setLoungeToEdit] = useState(null);

    const [role, setRole] = useState([])
    const toggleLoungeDialog = (e, mode = 'add', loungeToEdit = null) => {
        setLoungeDialogOpen(prev => !prev);
        setLoungeDialogMode(mode);
        setLoungeToEdit(loungeToEdit);
    };

    const fetchLoungeData = () => {
        setLoading(true);
        axiosInstance
            .get(ApiEndPoints?.LOUNGE?.list)
            .then((response) => {
                setLoungeData(response?.data?.data?.loungeList);
                setTotalCount(response?.data.total)
                console.log("lounge response--------------------", response);
            })
            .catch((error) => {
                toastError(error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchLoungeData({
            currentPage: currentPage,
            pageSize: pageSize,
            search: search,
        });
    }, [currentPage, pageSize, search])

    return (
        <>
            <Grid container spacing={4} className="match-height">
                <PageHeader
                    title={
                        <Typography variant="h5">
                            <Translations text="Lounge" />
                        </Typography>
                    }
                    action={
                        (rolePremission?.permissions?.some(
                            item => item.permissionName === 'orglounge.create'
                        ) || isMasterAdmin === true) ? (
                            <Button variant="contained"
                                onClick={toggleLoungeDialog}
                            >
                                Add lounge
                            </Button>
                        ) : null
                    }

                />
                <Grid item xs={12}>
                    <Card>
                        <Box>
                            <Box sx={{ p: 5 }}>
                                <TableLounge
                                    search={search}
                                    loading={loading}
                                    rows={loungeData}
                                    totalCount={totalCount}
                                    setCurrentPage={setCurrentPage}
                                    currentPage={currentPage}
                                    setPageSize={setPageSize}
                                    pageSize={pageSize}
                                    // toggleEdit={toggleLoungeDialog}
                                    toggleStatus={toggleChangeStatusDialog}
                                // rolePremission={rolePremission}
                                // isMasterAdmin={isMasterAdmin}
                                // toggleDelete={toggleChangeStatusDialog}
                                />
                            </Box>

                        </Box>
                    </Card>
                </Grid>
            </Grid>

            <Dialoglounge
                open={loungeDialogOpen}
                toggle={toggleLoungeDialog}
                mode={loungeDialogMode}
                dataToEdit={loungeToEdit}
                role={role}
                onSuccess={() => {
                    fetchLoungeData({
                        currentPage: currentPage,
                        pageSize: pageSize,
                    });
                }}
            />

            <DialogApproveReject
                open={statusDialogOpen}
                toggle={toggleChangeStatusDialog}
                dataToEdit={statusToUpdate}
                type="lounge"
                onSuccess={() => {
                    fetchLoungeData({
                        currentPage: currentPage,
                        pageSize: pageSize,
                        search: search,
                    });
                }}
            />
        </>
    )
}
export default Lounge